import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timerToHrsMinsSec'
})
export class TimerToHrsMinsSecPipe implements PipeTransform {

  transform(timer: string, ...args: unknown[]): string {

    if(!timer)timer= '00:00:00';
    let hrsStr = (timer.split(':')[0]);
        let minsStr = timer.split(':')[1];
        let secsStr = timer.split(':')[2];
        let hrs = Math.floor(parseFloat(hrsStr));
        let mins = Math.floor(parseFloat(minsStr));
        let secs = Math.floor(parseFloat(secsStr));

        if(mins == 0 && hrs == 0){
            return `${secs}s`;
        }else if(hrs == 0){
          return `${mins}m`;
        }
      return `${hrs}:${mins} h`;
  }

}
